import { render, staticRenderFns } from "./mail.vue?vue&type=template&id=f35ce9e6&scoped=true&"
import script from "./mail.vue?vue&type=script&lang=js&"
export * from "./mail.vue?vue&type=script&lang=js&"
import style0 from "./mail.vue?vue&type=style&index=0&id=f35ce9e6&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "f35ce9e6",
  null
  
)

export default component.exports